module.exports = __webpack_public_path__ + "img/island-of-avalon.77411806.jpg";